import { GrowthContent } from '@mc/api'

import { HeroCTA } from '../HeroCTA'
import { HeroDualImageTiles } from './HeroDualImageTiles'
import { HeroSingleImageTile } from './HeroSingleImageTile'

interface HeroMobileProps {
  heading: string
  courseA: GrowthContent
  courseB: GrowthContent
}

export const HeroMobile = ({ heading, courseA, courseB }: HeroMobileProps) => (
  <section className='d-lg-none mc-mb-8'>
    <SubcatHeroImages courseA={courseA} courseB={courseB} />
    <div className='container'>
      <h1 className='mc-mb-8 mc-text-d3 mc-text--brand mc-text--uppercase mc-text--center'>
        {heading}
      </h1>
      <HeroCTA headline={heading} fullWidth />
    </div>
  </section>
)

const SubcatHeroImages = ({
  courseA,
  courseB,
}: Omit<HeroMobileProps, 'heading'>) => {
  if (courseA?.primary16x9 && courseB?.primary16x9) {
    return (
      <HeroDualImageTiles
        img1Url={courseA.primary16x9}
        img1Alt={courseA.instructorName || ''}
        img2Url={courseB.primary16x9}
        img2Alt={courseB.instructorName || ''}
      />
    )
  }

  if (courseA?.primary16x9) {
    return (
      <HeroSingleImageTile
        imgUrl={courseA.primary16x9}
        imgAlt={courseA.instructorName || ''}
      />
    )
  }

  return null
}
